import React from "react";

const RibbonIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>ribbon-icon</title>
      <path
        d="M11.997 1.995l.017 11.63-3.497-2.084c-.316-.187-.708-.187-1.024 0l-3.485 2.1V1.996h7.994-.005zm-9.992 12.38c-.046.58.25 1.137.757 1.425.507.288 1.135.257 1.612-.08L8 13.565l3.622 2.155c.477.338 1.106.37 1.614.08.508-.287.804-.843.76-1.426V2c0-1.105-.895-2-2-2H4.004C2.9 0 2.005.895 2.005 2v12.374z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default RibbonIcon;
